<template>
  <v-navigation-drawer
    app
    id="nav-drawer"
    v-model="isNavigationDrawerOpen"
    color="background"
    temporary
    elevation="8"
    width="400"
    style="overflow-y: hidden !important; z-index: 20000; max-width: 90%"
    right
  >
    <nav-drawer-header />

    <!-- Tabs  ------------------------------------------------------------>
    <v-tabs
      id="navTabs"
      v-if="isNavigationDrawerOpen"
      v-model="tab"
      slider-size="5"
      slider-color="primary"
      :background-color="navDrawer.tabsBg"
      :color="navDrawer.tabsColor"
      :dark="navDrawer.tabsDark"
      grow
      center-active
      icons-and-text
      height="55"
    >
      <v-tab class="tabHeader" :class="`${navDrawer.tabsColor}--text`"
        >Module
        <v-icon :color="tabsIconColor" small>mdi-view-list</v-icon>
      </v-tab>
      <v-tab class="tabHeader" :class="`${navDrawer.tabsColor}--text`"
        >Sendbox
        <v-icon :color="tabsIconColor" small>mdi-sync</v-icon>
      </v-tab>
      <v-tab class="tabHeader" :class="`${navDrawer.tabsColor}--text`"
        >{{ $t('settings') }}
        <v-icon :color="tabsIconColor" small>mdi-cog</v-icon>
      </v-tab>
    </v-tabs>
    <!-- </div> -->

    <v-tabs-items v-model="tab" v-if="isNavigationDrawerOpen">
      <!-- <v-tabs-items v-model="tab" style="max-height:calc(100vh - 200px)"> -->
      <!-- All Modules -->
      <v-tab-item>
        <div v-if="tab === 0" class="scroll-container" :style="`height:calc(100vh - 200px)`">
          <n-module-list class="margin-last-child"></n-module-list>
        </div>
      </v-tab-item>

      <!-- sendbox content -->

      <v-tab-item>
        <div v-if="tab === 1" class="scroll-container" :style="`height:calc(100vh - 200px)`">
          <sendbox v-if="tab === 1" :sendbox="sendbox"></sendbox>
        </div>
      </v-tab-item>

      <!-- Settings -->
      <v-tab-item>
        <div v-if="tab === 2" class="scroll-container" :style="`height:calc(100vh - 200px)`">
          <settings />
        </div>
      </v-tab-item>
    </v-tabs-items>

    <v-footer
      height="70"
      absolute
      :color="navDrawer.tabsBg"
      dark
      v-if="isNavigationDrawerOpen"
      @click="isReleaseNotesDialogOpen = true"
      class="d-flex flex-wrap full-width"
    >
      <div class="caption pr-8" @click="isReleaseNotesDialogOpen = true">&copy; InnoTix AG | Version {{ appVersion }}</div>
      <v-spacer></v-spacer>
      <!--      <div style="justify-items: flex-end; height: 100%; width: 40px; border: 1px solid red" @click="isBrowserInfoOpen=true"></div>-->
      <v-menu offset-y top style="z-index: 100000">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-icon :color="navDrawer.tabsBg">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <!-- Device Information -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t('deviceInfo') }}</v-list-item-title>
              <div class="caption" style="white-space: break-spaces">{{ deviceUUID }}</div>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item class="pb-8">
            <v-list-item-content>
              <v-list-item-title>{{ $t('browserInfo') }}</v-list-item-title>
              <div class="caption flex-wrap">{{ browserInfo }}</div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-footer>
    <release-notes-dialog v-if="isNavigationDrawerOpen" v-model="isReleaseNotesDialogOpen"></release-notes-dialog>
  </v-navigation-drawer>
</template>
<script>
import NavDrawerHeader from './NavDrawerHeader';
import NModuleList from './ModuleList';
import Settings from './Settings';

import { mapState } from 'vuex';
import common from '@/mixins/common';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import Sendbox from '@/components/sendbox/Sendbox.vue';
import ReleaseNotesDialog from '@/dialogs/ReleaseNotesDialog.vue';
import configs from '@/common/config';
import config from "@/common/config";

export default {
  name: 'NavDrawer',
  mixins: [common, dateTimeMixin],
  components: { ReleaseNotesDialog, NModuleList, NavDrawerHeader, Settings, Sendbox },
  data() {
    return {
      tab: 2,
      isReleaseNotesDialogOpen: false,
      isBrowserInfoOpen: false,
    };
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      moduleConfigs: (state) => state.configs.moduleConfigs,
    }),
    navDrawer() {
      return this.theme.navDrawer;
    },
    tabsIconColor() {
      return ''; //'white'; //'background darken-2';
    },
    sendbox() {
      return this.isNavigationDrawerOpen && this.tab === 1 ? this.$store.getters['sendbox/getSendbox']() : [];
    },
    browserInfo() {
      let { os, browser, browserVersion, mobile, screen } = configs.browserInfo;
      return `${os},${mobile ? 'mobile' : ''} ${browser},${browserVersion}, ${screen}`;
    },
    deviceUUID() {
      return localStorage.getItem('deviceUUID');
    },
    appVersion() {return config.appVersion},
    isNavigationDrawerOpen: {
      get() {
        return this.$store.state.isNavigationDrawerOpen;
      },
      set(value) {
        if (value !== this.$store.state.isNavigationDrawerOpen) {
          this.$store.commit('toggleNavigationDrawer', value);
        }
      },
    },
  },

  watch: {
    isNavigationDrawerOpen(newValue, oldValue) {
      // Whenever drawer opens, select module list tab
      if (newValue) {
        this.tab = 2;
      }
      this.isReleaseNotesDialogOpen = false;
    },
  },
};
</script>
<style scoped>
.margin-last-child:nth-last-child(1) {
  margin-bottom: 30px;
}

.tabHeader {
  font-size: 11px;
}

.nav-item {
  height: 50px;
  padding-left: 20px;
  margin-top: 0;
  margin-bottom: 0;
}

#navTabs .v-slide-group__prev .v-slide-group__prev--disabled {
  width: 0 !important;
}

.browser-info {
  display: flex;
  font-size: 11px;
  color: #a0a0a0;
}
</style>
